import React from 'react';
import { Typography } from '@mui/material';
import { appColors, pageTitles } from '../../shared/utils/constants';

const TheHeader = () => {
  const getTitle = () => {
    const currentUrl = window.location.href;
    const foundTitle = Object.entries(pageTitles).find(([key, value]) => currentUrl.includes(key));

    return foundTitle ? foundTitle[1] : 'Home'; // Fallback title if no match is found
  };

  return (
    <Typography variant="h2">
      <span style={{color:appColors.brand}}>{getTitle()}</span>
    </Typography>
  );
};

export default TheHeader;
